import { useEffect, useRef } from "react";
import { Animated } from "react-native";

type AnimatedStyle = {
	transform: { scale: Animated.Value }[];
	opacity: Animated.Value;
};

export const useTTSAnimation = (isPlaying: boolean): AnimatedStyle => {
	const scaleAnim = useRef(new Animated.Value(1)).current;
	const opacityAnim = useRef(new Animated.Value(0)).current;
	const animationRef = useRef<Animated.CompositeAnimation | null>(null);

	useEffect(() => {
		if (isPlaying) {
			if (animationRef.current) {
				animationRef.current.stop();
			}

			animationRef.current = Animated.loop(
				Animated.parallel([
					Animated.sequence([
						Animated.timing(scaleAnim, {
							toValue: 1.2,
							duration: 1000,
							useNativeDriver: true,
						}),
						Animated.timing(scaleAnim, {
							toValue: 1,
							duration: 1000,
							useNativeDriver: true,
						}),
					]),
					Animated.sequence([
						Animated.timing(opacityAnim, {
							toValue: 0.2,
							duration: 1000,
							useNativeDriver: true,
						}),
						Animated.timing(opacityAnim, {
							toValue: 0,
							duration: 1000,
							useNativeDriver: true,
						}),
					]),
				]),
			);
			animationRef.current.start();
		} else {
			if (animationRef.current) {
				animationRef.current.stop();
				animationRef.current = null;
			}

			Animated.parallel([
				Animated.timing(scaleAnim, {
					toValue: 1,
					duration: 300,
					useNativeDriver: true,
				}),
				Animated.timing(opacityAnim, {
					toValue: 0,
					duration: 300,
					useNativeDriver: true,
				}),
			]).start();
		}

		return () => {
			if (animationRef.current) {
				animationRef.current.stop();
			}
		};
	}, [isPlaying, scaleAnim, opacityAnim]);

	return {
		transform: [{ scale: scaleAnim }],
		opacity: opacityAnim,
	};
};
